/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { SectionCard, Tabs } from '../../ui';
import Curriculum from '../../detail/components/curriculum';
import SpecialCourses from '../../detail/components/specialCourse';
import PlanCourses from '../../detail/components/planCourse';
import ChatListView from '@/pages/user/components/ChatListView';

/**
 * 服务资料 —— 四个**不同数据集**（不是同一实体的多段信息），因此
 * 按判据保留 Tab；但**拉平到同层**：原先它们是 SubNav 里「服务资料」的
 * 嵌套下拉项（点开才知道有四项），那才是真正的"三层"。
 *
 * 当前项只在服务资料页面内切换，不同步到 URL。
 */
const SERVICE_TABS = [
  { key: 'curriculum', label: '指导课课表' },
  { key: 'course', label: '课程' },
  { key: 'chat', label: '会话记录' },
  { key: 'plan', label: '专属计划' },
];

/* 导航与内容同一个来源：上面一份常量既生成 Tab，也决定内容，
   不再手写两遍（写两遍就会出现「菜单叫这名字、内容却是另一个」的漂移）。 */
const SERVICE_PANES = (tenantId) => ({
  curriculum: <Curriculum tenantId={tenantId} />,
  course: <SpecialCourses tenantId={tenantId} />,
  chat: <ChatListView tenantId={tenantId} />,
  plan: <PlanCourses tenantId={tenantId} />,
});

export const ServicePanes = (props) => {
  const { tenantId } = props;
  const [profileService, setProfileService] = useState('curriculum');
  /* 只认已知项：状态异常时回落到第一个数据集，避免四个 TabPane
     全不命中导致「只有 Tab 头、没有内容」的空白 */
  const raw = profileService;
  const item = SERVICE_TABS.some((t) => t.key === raw) ? raw : 'curriculum';
  const panes = SERVICE_PANES(tenantId);

  return (
    <SectionCard
      title="服务资料"
      subtitle="四个独立数据集：指导课课表 / 课程 / 会话记录 / 专属计划"
    >
      {/* destroyInactiveTabPane：切走即卸载 —— 这四个组件体量很大
          （curriculum 1323 行等），保留挂载会白占内存；也与改造前
          「if/else 只渲染一个」的行为一致。（首渲染时只挂载当前那个） */}
      <Tabs
        activeKey={item}
        onChange={setProfileService}
        destroyInactiveTabPane
      >
        {SERVICE_TABS.map((t) => (
          <Tabs.TabPane tab={t.label} key={t.key}>
            {panes[t.key]}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </SectionCard>
  );
};

export default ServicePanes;
